var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHyperledger(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 50",
    style: {
      enableBackground: "new 0 0 120 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A5A8B6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000096745422287023299710000008425786254455116467_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.7,35.7c-0.1,0-0.1,0-0.1-0.1L3,26.3c0-0.1,0-0.1,0-0.1l4.7-10.3c0-0.1,0.1-0.1,0.1-0.1l11.3-1.1 c0.1,0,0.1,0,0.1,0.1l6.6,9.3c0,0.1,0,0.1,0,0.1L21,34.5c0,0.1-0.1,0.1-0.1,0.1L9.7,35.7L9.7,35.7z M3.3,26.3l6.5,9.2l11.2-1 l4.7-10.2L19.2,15L8,16L3.3,26.3z M21,34.6L21,34.6L21,34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.7,35.7l-1.8-9.5V15.9l8.9,2.6l9.2,5.7l-6.9,6.1L9.7,35.7z M7.9,16v10.2l1.8,9.3l9.2-5.3l6.7-6l-9.1-5.6 L7.9,16z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16.9,
    cy: 18.6,
    r: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.9,19.3c-0.3,0-0.7-0.3-0.7-0.7c0-0.3,0.3-0.7,0.7-0.7c0.3,0,0.7,0.3,0.7,0.7 C17.5,19,17.2,19.3,16.9,19.3z M16.9,18.6L16.9,18.6C16.8,18.6,16.9,18.6,16.9,18.6L16.9,18.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 19.1,
    cy: 30.2,
    r: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.1,30.9c-0.3,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0.3,0,0.7,0.3,0.7,0.7 C19.8,30.6,19.4,30.9,19.1,30.9z M19.1,30.2L19.1,30.2C19,30.2,19,30.2,19.1,30.2L19.1,30.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 9.8,
    cy: 35.6,
    r: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.8,36.3c-0.3,0-0.7-0.3-0.7-0.7c0-0.3,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7S10.2,36.3,9.8,36.3z M9.8,35.6 L9.8,35.6L9.8,35.6L9.8,35.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 7.9,
    cy: 26.3,
    r: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.9,27c-0.3,0-0.7-0.3-0.7-0.7c0-0.3,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7S8.3,27,7.9,27z M7.9,26.3 L7.9,26.3C7.9,26.3,7.9,26.4,7.9,26.3L7.9,26.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 25.8,
    cy: 24.2,
    r: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.8,24.9c-0.3,0-0.7-0.3-0.7-0.7c0-0.3,0.3-0.7,0.7-0.7c0.3,0,0.7,0.3,0.7,0.7S26.2,24.9,25.8,24.9z  M25.8,24.2L25.8,24.2L25.8,24.2L25.8,24.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 7.9,
    cy: 15.9,
    r: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.9,16.6c-0.3,0-0.7-0.3-0.7-0.7c0-0.3,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7C8.6,16.3,8.3,16.6,7.9,16.6z  M7.9,15.9L7.9,15.9C7.9,16,7.9,16,7.9,15.9L7.9,15.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21,34.7L21,34.7l-8.7-3.1L3,26.4c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0.1-0.1l7-6.4l9.1-5c0.1,0,0.1,0,0.1,0 l0.1,0.1l2,9l-0.2,10.7C21.1,34.6,21.1,34.6,21,34.7C21.1,34.7,21,34.7,21,34.7z M3.3,26.2l9.1,5.1l8.5,3l0.2-10.5l-2-8.8 l-8.9,4.9L3.3,26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.1,30.3L19.1,30.3L7.8,26.4l0.1-0.1l9-7.8L19.1,30.3z M7.9,26.3L19,30.1l-2.2-11.5L7.9,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,31.7l-2.4-12l11.5,4.1L12.3,31.7z M10.3,20l2.2,11.2l8.6-7.4L10.3,20z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.9,
    y: 15.6,
    transform: "matrix(0.8718 -0.4898 0.4898 0.8718 -7.5955 6.6892)",
    className: "st0",
    width: 0.2,
    height: 4.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.9,35.7 9.7,35.5 12.3,31.4 12.5,31.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.4,
    y: 21.8,
    transform: "matrix(7.287417e-02 -0.9973 0.9973 7.287417e-02 -2.2095 45.7668)",
    className: "st0",
    width: 0.2,
    height: 4.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31,21.4h1.8v3.1h3.5v-3.1h1.8v8.3h-1.8v-3.5h-3.5v3.5H31V21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.8,26.1l-3.1-4.8H41l1.7,3.1l1.9-3.1h2.1l-3.1,4.8v3.5h-1.8L41.8,26.1L41.8,26.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.2,21.4h3.1c0.4,0,0.8,0.1,1.2,0.1c0.4,0.1,0.7,0.2,1,0.4c0.3,0.2,0.5,0.5,0.7,0.8s0.2,0.8,0.2,1.2 c0,0.5-0.1,0.9-0.2,1.2c-0.2,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.6,0.3-1,0.4c-0.3,0.1-0.8,0.1-1.2,0.1h-1.3v3.2h-1.8L47.2,21.4 L47.2,21.4L47.2,21.4z M48.9,24.9h1.2c0.2,0,0.3,0,0.5-0.1s0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.1-0.5 s-0.1-0.4-0.2-0.5S51,23.1,50.9,23c-0.2-0.1-0.3-0.1-0.5-0.1s-0.3,0-0.5,0H49L48.9,24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.5,21.4h5.6v1.7h-3.8v1.6h3.6v1.7h-3.6V28h4v1.7h-5.8V21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.6,21.4h3.2c0.4,0,0.8,0.1,1.2,0.1c0.4,0.1,0.7,0.2,1,0.4c0.3,0.2,0.5,0.5,0.7,0.8s0.2,0.7,0.2,1.2 c0,0.6-0.2,1.1-0.5,1.5s-0.8,0.7-1.3,0.8l2.1,3.5H66l-1.7-3.3h-0.9v3.3h-1.8L61.6,21.4L61.6,21.4L61.6,21.4z M63.5,24.8h1.1 c0.2,0,0.3,0,0.5,0s0.3-0.1,0.5-0.1c0.2-0.1,0.3-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.1-0.5c0-0.3-0.1-0.4-0.1-0.5 c-0.1-0.1-0.2-0.2-0.3-0.3C65.5,23,65.3,23,65.1,23s-0.3-0.1-0.5-0.1h-1.2L63.5,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.1,21.4H71V28h3.4v1.7h-5.2L69.1,21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.3,21.4h5.6v1.7h-3.8v1.6h3.6v1.7h-3.6V28h4v1.7h-5.8L75.3,21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.4,21.4h2.7c0.6,0,1.3,0.1,1.9,0.2c0.6,0.2,1.1,0.4,1.6,0.7c0.5,0.3,0.8,0.8,1,1.3 c0.3,0.5,0.4,1.2,0.4,1.9c0,0.7-0.1,1.3-0.4,1.7c-0.2,0.5-0.6,0.9-1,1.3c-0.4,0.3-0.9,0.6-1.5,0.8c-0.6,0.2-1.2,0.3-1.7,0.3h-2.9 L82.4,21.4z M84.3,28h0.9c0.4,0,0.8-0.1,1.2-0.1c0.3-0.1,0.7-0.2,0.9-0.4c0.3-0.2,0.5-0.5,0.6-0.8c0.2-0.3,0.2-0.7,0.2-1.2 c0-0.4-0.1-0.8-0.2-1c-0.2-0.3-0.3-0.5-0.6-0.8c-0.2-0.2-0.6-0.3-0.9-0.5c-0.3-0.1-0.7-0.2-1.1-0.1h-1.1L84.3,28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.7,29c-0.5,0.3-1.1,0.5-1.7,0.6s-1.2,0.2-1.8,0.2s-1.2-0.1-1.8-0.3c-0.5-0.2-1-0.5-1.4-0.9 c-0.4-0.3-0.7-0.8-0.9-1.4c-0.2-0.5-0.3-1.2-0.3-1.8c0-0.6,0.1-1.3,0.3-1.8c0.2-0.5,0.5-1,0.9-1.4s0.9-0.7,1.4-0.9 s1.2-0.3,1.8-0.3s1.3,0.1,1.8,0.2c0.6,0.2,1,0.4,1.4,0.8l-1.3,1.4c-0.2-0.2-0.5-0.5-0.8-0.6s-0.7-0.2-1.2-0.2 c-0.4,0-0.8,0.1-1,0.2c-0.3,0.1-0.6,0.3-0.8,0.6c-0.2,0.2-0.4,0.5-0.5,0.9c-0.1,0.3-0.2,0.7-0.2,1c0,0.4,0.1,0.8,0.2,1 c0.1,0.3,0.3,0.6,0.5,0.8s0.5,0.4,0.8,0.6c0.3,0.1,0.7,0.2,1,0.2c0.4,0,0.8-0.1,1-0.1c0.3-0.1,0.5-0.2,0.7-0.3v-1.3h-1.5v-1.7 h3.3L98.7,29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.3,21.4h5.6v1.7h-3.8v1.6h3.6v1.7h-3.6V28h4v1.7h-5.8L100.3,21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.4,21.4h3.2c0.4,0,0.8,0.1,1.2,0.1c0.4,0.1,0.7,0.2,1,0.4c0.3,0.2,0.5,0.5,0.7,0.8s0.2,0.7,0.2,1.2 c0,0.6-0.2,1.1-0.5,1.5s-0.8,0.6-1.3,0.8l2.1,3.5h-2.2l-1.7-3.3h-0.9v3.3h-1.8L107.4,21.4L107.4,21.4z M109.3,24.8h1.1 c0.2,0,0.3,0,0.5,0s0.3-0.1,0.5-0.1c0.2-0.1,0.3-0.2,0.3-0.3c0.1-0.1,0.2-0.3,0.2-0.5c0-0.3-0.1-0.4-0.1-0.5 c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.3-0.1-0.5-0.1s-0.3-0.1-0.5-0.1h-1.2V24.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperledger);
export default __webpack_public_path__ + "static/media/hyperledger.eb2621b5621aafef127118a827f9b40e.svg";
export { ForwardRef as ReactComponent };